// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"TY-z","smallCardRow":"UY-z","largeCardRow":"VY-z","productSearchRow":"WY-z","curatedRow":"XY-z"};